<template>
  <div id="faqSection">
    <div class="bg bg-top" />
    <div class="bg bg-bottom" />
    <b-container id="incentives">
      <div class="title">
        <img src="@/assets/images/faq/lightning-bolt-red.png" />
        Renewal Benefits
      </div>
    </b-container>
    <b-container class="accordion-container incentives" v-if="purl.accounts">
      <div class="accordion_wrapper">
        <Accordion
          v-for="(item, index) in benefitsData"
          :key="'benefits' + index"
          :accordionTitle="item.title"
          :accordionIcon="item.icon"
          @click="store.dispatch('purl/purlTracking', item.tracking)"
        >
          <p v-html="item.description" />
        </Accordion>
        <template v-if="purl.accounts[0].benefitSegment">
          <Accordion
            v-for="(item, index) in getBenefits(
              purl.accounts[0].benefitSegment
            )"
            :key="'getBenefits' + index"
            :accordionTitle="item.header"
            :accordionIcon="item.icon"
            @click="store.dispatch('purl/purlTracking', item.tracking)"
            ><div v-html="item.body"
          /></Accordion>
        </template>
      </div>
    </b-container>
    <b-container id="faq">
      <div class="title">
        <img src="@/assets/images/faq/lightning-bolt-red.png" />
        Renewal FAQ
      </div>
    </b-container>
    <b-container class="accordion-container">
      <div class="accordion_wrapper">
        <Accordion
          v-for="(item, index) in faqItems"
          :key="'faq' + index"
          :accordionTitle="item.header"
        >
          <p v-html="item.body" />
        </Accordion>
      </div>
    </b-container>
  </div>
</template>

<script>
import { reactive, toRefs, computed } from "vue";
import { useStore } from "vuex";
import Accordion from "@/components/Accordion";

export default {
  name: "Faq",
  components: {
    Accordion,
  },
  setup() {
    const store = useStore();

    // State
    const state = reactive({
      purl: computed(() => store.getters["purl/getAccount"]),
    });

    return { ...toRefs(state), store };
  },
  data() {
    return {
      benefitsData: [
        {
          icon: require("@/assets/images/benefits/relocation.png"),
          title: "relocation",
          tracking: "Relocation Benefit Clicked",
          description:
            // "One of the benefits of being a Season Ticket Member with the Detroit Pistons is priority access to our off-season seat relocation event. This event will be held both in person and online to offer you the convenience and flexibility to view available inventory. Please note, only those renewed for the 2022-23 season will have access to our relocation event and your access window will depend on your Season Ticket Member tenure.",
            "Season Ticket Members have priority access to our off-season seat relocation event. This event will be held both in person and online to offer you the convenience and flexibility to view available inventory. Please note, only those renewed for the 2022-23 season will have access to our relocation event and your access window will be determind by your Season Ticket Member tenure.",
        },
        {
          icon: require("@/assets/images/benefits/add-seats.png"),
          title: "add seats",
          tracking: "Add Seats Benefit Clicked",
          description: `You can now add seats to your plan! To add seats, please contact your Membership Services representative directly or call the Pistons Membership Development Team at <a href="tel:(313)771-0140">(313) 771-0140.</a>`,
        },
      ],
      faqItems: [
        {
          header: "What does auto-renewal mean?",
          body: "All season ticket accounts are automatically renewed each season. To opt-out, you must complete the cancellation form and speak directly with your Membership Experience representative, or your credit card will be charged on April 1st. If necessary, please contact your representative to update your payment plan or credit card before March.",
        },
        {
          header: "What is the deadline to renew my seats?",
          body: "March 31, 2022 is the deadline to renew your seats!",
        },
        {
          header:
            "How do I change my payment plan or credit card for auto-renewal?",
          body: `Please click <a href="https://am.ticketmaster.com/pistons/" target="_blank">HERE</a> to log in and update your credit card number or payment plan before March 31, 2022.`,
        },
        {
          header: "How will my 8-month payment plan work?",
          body: "Your credit card will be charged monthly, with the first payment being on April 1st. Your account will be charged on the 1st of every month for the duration of the 8-month billing cycle.",
        },
        {
          header: "How do I improve my seating location for next season?",
          body: "All renewed Pistons One Members will be invited to view relocation options at our annual Member Seat Relocation event in the spring. The event will be held at LCA as well as virtually.  Members will be given the opportunity to upgrade, relocate, and add-on seats to your membership. Your invitation and designated time slot are in priority order based on your tenure.",
        },
        {
          header: "How can I add additional seats to my account next season?",
          body: `To add seats, please contact your Membership Services representative directly or call the Pistons Membership Development Team at <a href="tel:(313)771-0140">(313) 771-0140</a>`,
        },
      ],
    };
  },
  methods: {
    getBenefits(segment) {
      // console.log("segment", segment);
      let benefitSegment = null;
      switch (segment) {
        case "SEGMENT A":
          benefitSegment = [
            {
              icon: require("@/assets/images/benefits/all-inclusive-dining.png"),
              header: "All-Inclusive Dining Amenities",
              tracking: "All-Inclusive Dining Amenities Benefit Clicked",
              body: `<ul><li>Enjoy all-inclusive dining including beer, wine and liquor with access to the unrivaled Players Club before, during and after Pistons games</li><li>Access to the exclusive CURE Insurance Courtside Club</li></ul>`,
            },
            {
              icon: require("@/assets/images/benefits/reserved-parking.png"),
              header: "Parking Amenities",
              tracking: "Parking Amenities Benefit Clicked",
              body: `<ul><li>Reserved parking in the Little Caesars Arena garage</li></ul>`,
            },
            {
              icon: require("@/assets/images/benefits/priority-access.png"),
              header: "Priority Access",
              tracking: "Priority Access Benefit Clicked",
              body: `<ul><li>Priority access to concert and event seating through The Prime Seat Program</li><li>VIP experiences and gifting at Pistons hosted events throughout the year</li><li>NEW: Access to annual Pistons Fall Fest</li><li>NEW: Access to Pistons Performance Center Meeting Spaces (restrictions apply)</li><li>NEW: Access to member Biergarten for select games at Little Caesars Arena</li><li>NEW: Priority access to new Pistons merchandise</li><li>Access to the Pistons ONE Rewards Program</li><li>Ticket Exchange Program (restrictions apply)</li><li>Opportunity to interact with the team at Pistons ONE Give Back Event</li><li>Access to Members Monthly email</li><li>A Dedicated Membership Experience Executive</li><li>NBA Playoff Priority ticket access</li></ul>`,
            },
            {
              icon: require("@/assets/images/benefits/exclusive-member-pricing.png"),
              header: "Exclusive Member Pricing",
              tracking: "Exclusive Member Pricing Benefit Clicked",
              body: `<ul><li>Single Game Member Pricing and Priority Purchasing</li><li>Exclusive merchandise discount at arena Team Store and <a href="https://www.pistons313shop.com/" target="_blank">Pistons313Shop.com</a></li><li>Special member priority and pricing for additional and group tickets</li></ul>`,
            },
          ];
          break;
        case "SEGMENT A (HALF)":
          benefitSegment = [
            {
              icon: require("@/assets/images/benefits/all-inclusive-dining.png"),
              header: "All-Inclusive Dining Amenities",
              tracking: "All-Inclusive Dining Amenities Benefit Clicked",
              body: `<ul><li>Enjoy all-inclusive dining including beer, wine and liquor with access to the unrivaled Players Club before, during and after Pistons games</li><li>Access to the exclusive CURE Insurance Courtside Club</li></ul>`,
            },
            {
              icon: require("@/assets/images/benefits/reserved-parking.png"),
              header: "Parking Amenities",
              tracking: "Parking Amenities Benefit Clicked",
              body: `<ul><li>Reserved parking in the Little Caesars Arena garage</li></ul>`,
            },
            {
              icon: require("@/assets/images/benefits/priority-access.png"),
              header: "Priority Access",
              tracking: "Priority Access Benefit Clicked",
              body: `<ul><li>Priority access to concert and event seating through The Prime Seat Program</li><li>VIP experiences and gifting at Pistons hosted events throughout the year</li><li>NEW: Access to annual Pistons Fall Fest</li><li>NEW: Access to Pistons Performance Center Meeting Spaces (restrictions apply)</li><li>NEW: Access to member Biergarten for select games at Little Caesars Arena</li><li>NEW: Priority access to new Pistons merchandise</li><li>Access to the Pistons ONE Rewards Program</li><li>Ticket Exchange Program (restrictions apply)</li><li>Access to Members Monthly email</li><li>A Dedicated Membership Experience Executive</li><li>NBA Playoff Priority ticket access</li></ul>`,
            },
            {
              icon: require("@/assets/images/benefits/exclusive-member-pricing.png"),
              header: "Exclusive Member Pricing",
              tracking: "Exclusive Member Pricing Benefit Clicked",
              body: `<ul><li>Single Game Member Pricing and Priority Purchasing</li><li>Exclusive merchandise discount at arena Team Store and <a href="https://www.pistons313shop.com/" target="_blank">Pistons313Shop.com</a></li><li>Special member priority and pricing for additional and group tickets</li></ul>`,
            },
          ];
          break;
        case "SEGMENT B":
          benefitSegment = [
            {
              icon: require("@/assets/images/benefits/all-inclusive-dining.png"),
              header: "All-Inclusive Dining Amenities",
              tracking: "All-Inclusive Dining Amenities Benefit Clicked",
              body: `<ul><li>Enjoy all-inclusive dining including beer and wine with access to the MotorCity Casino Club before and during Pistons games</li><li>Access to the exclusive CURE Insurance Courtside Club</li></ul>`,
            },
            {
              icon: require("@/assets/images/benefits/reserved-parking.png"),
              header: "Parking Amenities",
              tracking: "Parking Amenities Benefit Clicked",
              body: `<ul><li>Reserved parking in the Little Caesars Arena garage</li></ul>`,
            },
            {
              icon: require("@/assets/images/benefits/priority-access.png"),
              header: "Priority Access",
              tracking: "Priority Access Benefit Clicked",
              body: `<ul><li>VIP experiences and gifting at Pistons hosted events throughout the year</li><li>NEW: Access to annual Pistons Fall Fest</li><li>NEW: Access to Pistons Performance Center Meeting Spaces (restrictions apply)</li><li>NEW: Access to member Biergarten for select games at Little Caesars Arena</li><li>NEW: Priority access to new Pistons merchandise</li><li>Access to the Pistons ONE Rewards Program</li><li>Ticket Exchange Program (restrictions apply)</li><li>Access to Members Monthly email</li><li>A Dedicated Membership Experience Executive</li><li>NBA Playoff Priority ticket access</li></ul>`,
            },
            {
              icon: require("@/assets/images/benefits/exclusive-member-pricing.png"),
              header: "Exclusive Member Pricing",
              tracking: "Exclusive Member Pricing Benefit Clicked",
              body: `<ul><li>Single Game Member Pricing and Priority Purchasing</li><li>Exclusive merchandise discount at arena Team Store and <a href="https://www.pistons313shop.com/" target="_blank">Pistons313Shop.com</a></li><li>Special member priority and pricing for additional and group tickets</li></ul>`,
            },
          ];
          break;
        case "SEGMENT B (HALF)":
          benefitSegment = [
            {
              icon: require("@/assets/images/benefits/all-inclusive-dining.png"),
              header: "All-Inclusive Dining Amenities",
              tracking: "All-Inclusive Dining Amenities Benefit Clicked",
              body: `<ul><li>Enjoy all-inclusive dining including beer and wine with access to the MotorCity Casino Club before and during Pistons games</li><li>Access to the exclusive CURE Insurance Courtside Club</li></ul>`,
            },
            {
              icon: require("@/assets/images/benefits/reserved-parking.png"),
              header: "Parking Amenities",
              tracking: "Parking Amenities Benefit Clicked",
              body: `<ul><li>Reserved parking in the Little Caesars Arena garage</li></ul>`,
            },
            {
              icon: require("@/assets/images/benefits/priority-access.png"),
              header: "Priority Access",
              tracking: "Priority Access Benefit Clicked",
              body: `<ul><li>VIP experiences and gifting at Pistons hosted events throughout the year</li><li>NEW: Access to annual Pistons Fall Fest</li><li>NEW: Access to Pistons Performance Center Meeting Spaces (restrictions apply)</li><li>NEW: Access to member Biergarten for select games at Little Caesars Arena</li><li>NEW: Priority access to new Pistons merchandise</li><li>Access to the Pistons ONE Rewards Program</li><li>Ticket Exchange Program (restrictions apply)</li><li>Access to Members Monthly email</li><li>A Dedicated Membership Experience Executive</li><li>NBA Playoff Priority ticket access</li></ul>`,
            },
            {
              icon: require("@/assets/images/benefits/exclusive-member-pricing.png"),
              header: "Exclusive Member Pricing",
              tracking: "Exclusive Member Pricing Benefit Clicked",
              body: `<ul><li>Single Game Member Pricing and Priority Purchasing</li><li>Exclusive merchandise discount at arena Team Store and <a href="https://www.pistons313shop.com/" target="_blank">Pistons313Shop.com</a></li><li>Special member priority and pricing for additional and group tickets</li></ul>`,
            },
          ];
          break;
        case "SEGMENT C":
          benefitSegment = [
            {
              icon: require("@/assets/images/benefits/all-inclusive-dining.png"),
              header: "All-Inclusive Dining Amenities",
              tracking: "All-Inclusive Dining Amenities Benefit Clicked",
              body: `<ul><li>Enjoy all-inclusive dining including beer, wine and liquor with access to the unrivaled Players Club before, during and after Pistons games</li></ul>`,
            },
            {
              icon: require("@/assets/images/benefits/reserved-parking.png"),
              header: "Parking Amenities",
              tracking: "Parking Amenities Benefit Clicked",
              body: `<ul><li>Reserved parking in the Little Caesars Arena garage</li></ul>`,
            },
            {
              icon: require("@/assets/images/benefits/priority-access.png"),
              header: "Priority Access",
              tracking: "Priority Access Benefit Clicked",
              body: `<ul><li>NEW: Access to annual Pistons Fall Fest</li><li>NEW: Access to Pistons Performance Center Meeting Spaces (restrictions apply)</li><li>NEW: Access to member Biergarten for select games at Little Caesars Arena</li><li>NEW: Priority access to new Pistons merchandise</li><li>Access to the Pistons ONE Rewards Program</li><li>Ticket Exchange Program (restrictions apply)</li><li>Opportunity to interact with the team at Pistons ONE Give Back Event</li><li>Access to Members Monthly email</li><li>A Dedicated Membership Experience Executive</li><li>NBA Playoff Priority ticket access</li></ul>`,
            },
            {
              icon: require("@/assets/images/benefits/exclusive-member-pricing.png"),
              header: "Exclusive Member Pricing",
              tracking: "Exclusive Member Pricing Benefit Clicked",
              body: `<ul><li>Single Game Member Pricing and Priority Purchasing</li><li>Exclusive merchandise discount at arena Team Store and <a href="https://www.pistons313shop.com/" target="_blank">Pistons313Shop.com</a></li><li>Special member priority and pricing for additional and group tickets</li></ul>`,
            },
          ];
          break;
        case "SEGMENT C (HALF)":
          benefitSegment = [
            {
              icon: require("@/assets/images/benefits/all-inclusive-dining.png"),
              header: "All-Inclusive Dining Amenities",
              tracking: "All-Inclusive Dining Amenities Benefit Clicked",
              body: `<ul><li>Enjoy all-inclusive dining including beer, wine and liquor with access to the unrivaled Players Club before, during and after Pistons games</li></ul>`,
            },
            {
              icon: require("@/assets/images/benefits/reserved-parking.png"),
              header: "Parking Amenities",
              tracking: "Parking Amenities Benefit Clicked",
              body: `<ul><li>Reserved parking in the Little Caesars Arena garage</li></ul>`,
            },
            {
              icon: require("@/assets/images/benefits/priority-access.png"),
              header: "Priority Access",
              tracking: "Priority Access Benefit Clicked",
              body: `<ul><li>NEW: Access to annual Pistons Fall Fest</li><li>NEW: Access to Pistons Performance Center Meeting Spaces (restrictions apply)</li><li>NEW: Access to member Biergarten for select games at Little Caesars Arena</li><li>NEW: Priority access to new Pistons merchandise</li><li>Access to the Pistons ONE Rewards Program</li><li>Ticket Exchange Program (restrictions apply)</li><li>Access to Members Monthly email</li><li>A Dedicated Membership Experience Executive</li><li>NBA Playoff Priority ticket access</li></ul>`,
            },
            {
              icon: require("@/assets/images/benefits/exclusive-member-pricing.png"),
              header: "Exclusive Member Pricing",
              tracking: "Exclusive Member Pricing Benefit Clicked",
              body: `<ul><li>Single Game Member Pricing and Priority Purchasing</li><li>Exclusive merchandise discount at arena Team Store and <a href="https://www.pistons313shop.com/" target="_blank">Pistons313Shop.com</a></li><li>Special member priority and pricing for additional and group tickets</li></ul>`,
            },
          ];
          break;
        case "SEGMENT D":
          benefitSegment = [
            {
              icon: require("@/assets/images/benefits/all-inclusive-dining.png"),
              header: "All-Inclusive Dining Amenities",
              tracking: "All-Inclusive Dining Amenities Benefit Clicked",
              body: `<ul><li>Enjoy all-inclusive dining including beer and wine with access to the upscale Rehmann Club before and during Pistons games</li></ul>`,
            },
            {
              icon: require("@/assets/images/benefits/reserved-parking.png"),
              header: "Parking Amenities",
              tracking: "Parking Amenities Benefit Clicked",
              body: `<ul><li>Reserved parking in the Little Caesars Arena garage</li></ul>`,
            },
            {
              icon: require("@/assets/images/benefits/priority-access.png"),
              header: "Priority Access",
              tracking: "Priority Access Benefit Clicked",
              body: `<ul><li>NEW: Access to annual Pistons Fall Fest</li><li>NEW: Access to Pistons Performance Center Meeting Spaces (restrictions apply)</li><li>NEW: Access to member Biergarten for select games at Little Caesars Arena</li><li>NEW: Priority access to new Pistons merchandise</li><li>Access to the Pistons ONE Rewards Program</li><li>Ticket Exchange Program (restrictions apply)</li><li>Opportunity to interact with the team at Pistons ONE Give Back Event</li><li>Access to Members Monthly email</li><li>A Dedicated Membership Experience Executive</li><li>NBA Playoff Priority ticket access</li></ul>`,
            },
            {
              icon: require("@/assets/images/benefits/exclusive-member-pricing.png"),
              header: "Exclusive Member Pricing",
              tracking: "Exclusive Member Pricing Benefit Clicked",
              body: `<ul><li>Single Game Member Pricing and Priority Purchasing</li><li>Exclusive merchandise discount at arena Team Store and <a href="https://www.pistons313shop.com/" target="_blank">Pistons313Shop.com</a></li><li>Special member priority and pricing for additional and group tickets</li></ul>`,
            },
          ];
          break;
        case "SEGMENT D (HALF)":
          benefitSegment = [
            {
              icon: require("@/assets/images/benefits/all-inclusive-dining.png"),
              header: "All-Inclusive Dining Amenities",
              tracking: "All-Inclusive Dining Amenities Benefit Clicked",
              body: `<ul><li>Enjoy all-inclusive dining including beer and wine with access to the upscale Rehmann Club before and during Pistons games</li></ul>`,
            },
            {
              icon: require("@/assets/images/benefits/reserved-parking.png"),
              header: "Parking Amenities",
              tracking: "Parking Amenities Benefit Clicked",
              body: `<ul><li>Reserved parking in the Little Caesars Arena garage</li></ul>`,
            },
            {
              icon: require("@/assets/images/benefits/priority-access.png"),
              header: "Priority Access",
              tracking: "Priority Access Benefit Clicked",
              body: `<ul><li>NEW: Access to annual Pistons Fall Fest</li><li>NEW: Access to Pistons Performance Center Meeting Spaces (restrictions apply)</li><li>NEW: Access to member Biergarten for select games at Little Caesars Arena</li><li>NEW: Priority access to new Pistons merchandise</li><li>Access to the Pistons ONE Rewards Program</li><li>Ticket Exchange Program (restrictions apply)</li><li>Access to Members Monthly email</li><li>A Dedicated Membership Experience Executive</li><li>NBA Playoff Priority ticket access</li></ul>`,
            },
            {
              icon: require("@/assets/images/benefits/exclusive-member-pricing.png"),
              header: "Exclusive Member Pricing",
              tracking: "Exclusive Member Pricing Benefit Clicked",
              body: `<ul><li>Single Game Member Pricing and Priority Purchasing</li><li>Exclusive merchandise discount at arena Team Store and <a href="https://www.pistons313shop.com/" target="_blank">Pistons313Shop.com</a></li><li>Special member priority and pricing for additional and group tickets</li></ul>`,
            },
          ];
          break;
        case "SEGMENT E":
          benefitSegment = [
            {
              icon: require("@/assets/images/benefits/all-inclusive-dining.png"),
              header: "All-Inclusive Dining Amenities",
              tracking: "All-Inclusive Dining Amenities Benefit Clicked",
              body: `<ul><li>Enjoy all-inclusive dining including beer and wine with access to the MotorCity Club before and during Pistons games</li></ul>`,
            },
            {
              icon: require("@/assets/images/benefits/reserved-parking.png"),
              header: "Parking Amenities",
              tracking: "Parking Amenities Benefit Clicked",
              body: `<ul><li>Reserved parking in the Little Caesars Arena garage</li></ul>`,
            },
            {
              icon: require("@/assets/images/benefits/priority-access.png"),
              header: "Priority Access",
              tracking: "Priority Access Benefit Clicked",
              body: `<ul><li>NEW: Access to annual Pistons Fall Fest</li><li>NEW: Access to Pistons Performance Center Meeting Spaces (restrictions apply)</li><li>NEW: Access to member Biergarten for select games at Little Caesars Arena</li><li>NEW: Priority access to new Pistons merchandise</li><li>Access to the Pistons ONE Rewards Program</li><li>Ticket Exchange Program (restrictions apply)</li><li>Opportunity to interact with the team at Pistons ONE Give Back Event</li><li>Access to Members Monthly email</li><li>A Dedicated Membership Experience Executive</li><li>NBA Playoff Priority ticket access</li></ul>`,
            },
            {
              icon: require("@/assets/images/benefits/exclusive-member-pricing.png"),
              header: "Exclusive Member Pricing",
              tracking: "Exclusive Member Pricing Benefit Clicked",
              body: `<ul><li>Single Game Member Pricing and Priority Purchasing</li><li>Exclusive merchandise discount at arena Team Store and <a href="https://www.pistons313shop.com/" target="_blank">Pistons313Shop.com</a></li><li>Special member priority and pricing for additional and group tickets</li></ul>`,
            },
          ];
          break;
        case "SEGMENT E (HALF)":
          benefitSegment = [
            {
              icon: require("@/assets/images/benefits/all-inclusive-dining.png"),
              header: "All-Inclusive Dining Amenities",
              tracking: "All-Inclusive Dining Amenities Benefit Clicked",
              body: `<ul><li>Enjoy all-inclusive dining including beer and wine with access to the MotorCity Casino Club before and during Pistons games</li></ul>`,
            },
            {
              icon: require("@/assets/images/benefits/reserved-parking.png"),
              header: "Parking Amenities",
              tracking: "Parking Amenities Benefit Clicked",
              body: `<ul><li>Reserved parking in the Little Caesars Arena garage</li></ul>`,
            },
            {
              icon: require("@/assets/images/benefits/priority-access.png"),
              header: "Priority Access",
              tracking: "Priority Access Benefit Clicked",
              body: `<ul><li>NEW: Access to annual Pistons Fall Fest</li><li>NEW: Access to Pistons Performance Center Meeting Spaces (restrictions apply)</li><li>NEW: Access to member Biergarten for select games at Little Caesars Arena</li><li>NEW: Priority access to new Pistons merchandise</li><li>Access to the Pistons ONE Rewards Program</li><li>Ticket Exchange Program (restrictions apply)</li><li>Access to Members Monthly email</li><li>A Dedicated Membership Experience Executive</li><li>NBA Playoff Priority ticket access</li></ul>`,
            },
            {
              icon: require("@/assets/images/benefits/exclusive-member-pricing.png"),
              header: "Exclusive Member Pricing",
              tracking: "Exclusive Member Pricing Benefit Clicked",
              body: `<ul><li>Single Game Member Pricing and Priority Purchasing</li><li>Exclusive merchandise discount at arena Team Store and <a href="https://www.pistons313shop.com/" target="_blank">Pistons313Shop.com</a></li><li>Special member priority and pricing for additional and group tickets</li></ul>`,
            },
          ];
          break;
        case "SEGMENT F":
          benefitSegment = [
            {
              icon: require("@/assets/images/benefits/all-inclusive-dining.png"),
              header: "All-Inclusive Dining Amenities",
              tracking: "All-Inclusive Dining Amenities Benefit Clicked",
              body: `<ul><li>Enjoy all-inclusive dining including beer and wine with access to the Legends Club before and during Pistons games</li></ul>`,
            },
            {
              icon: require("@/assets/images/benefits/reserved-parking.png"),
              header: "Parking Amenities",
              tracking: "Parking Amenities Benefit Clicked",
              body: `<ul><li>Reserved parking in the Little Caesars Arena garage</li></ul>`,
            },
            {
              icon: require("@/assets/images/benefits/priority-access.png"),
              header: "Priority Access",
              tracking: "Priority Access Benefit Clicked",
              body: `<ul><li>NEW: Access to annual Pistons Fall Fest</li><li>NEW: Access to Pistons Performance Center Meeting Spaces (restrictions apply)</li><li>NEW: Access to member Biergarten for select games at Little Caesars Arena</li><li>NEW: Priority access to new Pistons merchandise</li><li>Access to the Pistons ONE Rewards Program</li><li>Ticket Exchange Program (restrictions apply)</li><li>Opportunity to interact with the team at Pistons ONE Give Back Event</li><li>Access to Members Monthly email</li><li>A Dedicated Membership Experience Executive</li><li>NBA Playoff Priority ticket access</li></ul>`,
            },
            {
              icon: require("@/assets/images/benefits/exclusive-member-pricing.png"),
              header: "Exclusive Member Pricing",
              tracking: "Exclusive Member Pricing Benefit Clicked",
              body: `<ul><li>Single Game Member Pricing and Priority Purchasing</li><li>Exclusive merchandise discount at arena Team Store and <a href="https://www.pistons313shop.com/" target="_blank">Pistons313Shop.com</a></li><li>Special member priority and pricing for additional and group tickets</li></ul>`,
            },
          ];
          break;
        case "SEGMENT F (HALF)":
          benefitSegment = [
            {
              icon: require("@/assets/images/benefits/all-inclusive-dining.png"),
              header: "All-Inclusive Dining Amenities",
              tracking: "All-Inclusive Dining Amenities Benefit Clicked",
              body: `<ul><li>Enjoy all-inclusive dining including beer and wine with access to the Legends Club before and during Pistons games</li></ul>`,
            },
            {
              icon: require("@/assets/images/benefits/reserved-parking.png"),
              header: "Parking Amenities",
              tracking: "Parking Amenities Benefit Clicked",
              body: `<ul><li>Reserved parking in the Little Caesars Arena garage</li></ul>`,
            },
            {
              icon: require("@/assets/images/benefits/priority-access.png"),
              header: "Priority Access",
              tracking: "Priority Access Benefit Clicked",
              body: `<ul><li>NEW: Access to annual Pistons Fall Fest</li><li>NEW: Access to Pistons Performance Center Meeting Spaces (restrictions apply)</li><li>NEW: Access to member Biergarten for select games at Little Caesars Arena</li><li>NEW: Priority access to new Pistons merchandise</li><li>Access to the Pistons ONE Rewards Program</li><li>Ticket Exchange Program (restrictions apply)</li><li>Access to Members Monthly email</li><li>A Dedicated Membership Experience Executive</li><li>NBA Playoff Priority ticket access</li></ul>`,
            },
            {
              icon: require("@/assets/images/benefits/exclusive-member-pricing.png"),
              header: "Exclusive Member Pricing",
              tracking: "Exclusive Member Pricing Benefit Clicked",
              body: `<ul><li>Single Game Member Pricing and Priority Purchasing</li><li>Exclusive merchandise discount at arena Team Store and <a href="https://www.pistons313shop.com/" target="_blank">Pistons313Shop.com</a></li><li>Special member priority and pricing for additional and group tickets</li></ul>`,
            },
          ];
          break;
        case "SEGMENT G":
          benefitSegment = [
            {
              icon: require("@/assets/images/benefits/priority-access.png"),
              header: "Priority Access",
              tracking: "Priority Access Benefit Clicked",
              body: `<ul><li>NEW: Access to annual Pistons Fall Fest</li><li>NEW: Access to member Biergarten for select games at Little Caesars Arena</li><li>NEW: Priority access to new Pistons merchandise</li><li>Access to the Pistons ONE Rewards Program</li><li>Ticket Exchange Program (restrictions apply)</li><li>Opportunity to interact with the team at Pistons ONE Give Back Event</li><li>Access to Members Monthly email</li><li>A Dedicated Membership Experience Executive</li><li>NBA Playoff Priority ticket access</li></ul>`,
            },
            {
              icon: require("@/assets/images/benefits/exclusive-member-pricing.png"),
              header: "Exclusive Member Pricing",
              tracking: "Exclusive Member Pricing Benefit Clicked",
              body: `<ul><li>Single Game Member Pricing and Priority Purchasing</li><li>Exclusive merchandise discount at arena Team Store and <a href="https://www.pistons313shop.com/" target="_blank">Pistons313Shop.com</a></li><li>Special member priority and pricing for additional and group tickets</li></ul>`,
            },
          ];
          break;
        case "SEGMENT G (HALF)":
          benefitSegment = [
            {
              icon: require("@/assets/images/benefits/priority-access.png"),
              header: "Priority Access",
              tracking: "Priority Access Benefit Clicked",
              body: `<ul><li>NEW: Access to annual Pistons Fall Fest</li><li>NEW: Access to member Biergarten for select games at Little Caesars Arena</li><li>NEW: Priority access to new Pistons merchandise</li><li>Access to the Pistons ONE Rewards Program</li><li>Ticket Exchange Program (restrictions apply)</li><li>Access to Members Monthly email</li><li>A Dedicated Membership Experience Executive</li><li>NBA Playoff Priority ticket access</li></ul>`,
            },
            {
              icon: require("@/assets/images/benefits/exclusive-member-pricing.png"),
              header: "Exclusive Member Pricing",
              tracking: "Exclusive Member Pricing Benefit Clicked",
              body: `<ul><li>Single Game Member Pricing and Priority Purchasing</li><li>Exclusive merchandise discount at arena Team Store and <a href="https://www.pistons313shop.com/" target="_blank">Pistons313Shop.com</a></li><li>Special member priority and pricing for additional and group tickets</li></ul>`,
            },
          ];
          break;
      }
      return benefitSegment;
    },
  },
};
</script>

<style lang="scss" scoped>
#faqSection {
  display: flex;
  flex-direction: column;
  position: relative;
  background: url("~@/assets/images/benefits/bg-texture.jpg");
  background-size: cover;
  background-repeat: no-repeat;
  display: flex;
  position: relative;
  padding: 134px 0 175px 0;
  @media (min-width: 992px) {
    background-attachment: fixed;
  }
  .bg {
    position: absolute;
    left: 0;
    background: url("~@/assets/images/benefits/checkers.png");
    background-size: cover;
    background-repeat: no-repeat;
    height: 67px;
    width: 100%;
    &-top {
      top: 0;
    }
    &-bottom {
      bottom: 0;
    }
  }
  .container {
    @media (max-width: 767px) {
      max-width: 100vw;
    }
    &.accordion-container {
      @media (max-width: 500px) {
        max-width: 100vw;
        padding: 0;
      }
    }
    &.incentives {
      margin-bottom: 50px;
    }
    .title {
      position: relative;
      font-family: Birdrockers;
      font-weight: normal;
      font-size: 52px;
      line-height: 52px;
      letter-spacing: normal;
      color: #ffffff;
      @media (max-width: 767px) {
        font-size: 42px;
        line-height: 42px;
      }
      @media (max-width: 400px) {
        font-size: 37px;
        line-height: 37px;
      }
      img {
        width: 77px;
        object-fit: contain;
        @media (max-width: 767px) {
          width: 66px;
        }
      }
    }
    .accordion_wrapper {
      margin-top: 22px;
    }
  }
}
</style>